import { render } from "./VideoStream.vue?vue&type=template&id=806a1bd2&scoped=true"
import script from "./VideoStream.vue?vue&type=script&lang=js"
export * from "./VideoStream.vue?vue&type=script&lang=js"

import "./VideoStream.vue?vue&type=style&index=0&id=806a1bd2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mudassir\\Retrocausal\\portal_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-806a1bd2"]])

export default __exports__